module.exports = __webpack_public_path__ + "static/img/11.a34afe8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/eng/11.png
// module id = Z9xJ
// module chunks = 0